import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { getInvoiceData } from '../Api/ViewPostedInvoice';
import { Base_URL } from "../url";
import { useReactToPrint } from "react-to-print";
import { useParams } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import PoPrintHeader from "./poPrintHeader";
import PoPrintBody from "./poPrintBody";
import InvoiceFooter from "./InvoiceFooter";
import "../Styling/poCss/purchaseOrder.css"
import PoFooter from "./PoFooter";

const { ToWords } = require('to-words');





const PoPrint = () => {
  const { id } = useParams();
  const [poData,setPoData]=useState();
  const componentRef = useRef();
  // how many copies to print
  const [prints, setPrints] = useState(1);
  const[loading,setLoading]=useState(true);
  // This ref will be used by react-to-print
  const printRef = useRef(null);

  const handlePrint = useReactToPrint({
    contentRef: componentRef, // ✅ new API for v3+
    documentTitle: "Invoice",
  });

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const res = await axios.get(
          `${Base_URL}/PurchaseOrder/purchaseOrderItems/id`,
          { params: { id } }
        );
        if (!active) return;
        setPoData(res.data);
    
      } catch (e) {
        toast.error("Failed to fetch PO items");
        console.error(e);
      } finally {
        if (active) setLoading(false);
      }
    })();
    return () => {
      active = false;
    };
  }, [id]);
  console.log(poData);
  return (
    <>
      {/* ===== Download Button Row ===== */}
      <div className="container-fluid no-print">
  <div className="row mt-5">
    <div className="col-8 mt-5"></div>

    <div className="col-4 text-end mt-5 d-flex justify-content-end align-items-center">
      <label className="me-2 fw-semibold prints-label">
  Enter Number of Prints
</label>


      <input
        
        value={prints}
        onChange={(e) => setPrints(e.target.value)}
        className="prints-input me-2"
      />

      <button className="btn btn-primary" onClick={handlePrint}>
        Download Purchase Order
      </button>
    </div>
  </div>
</div>


   
    <div ref={componentRef}>
  {/* original invoice copy */}
  {/* <div className="po-page">
    <PoPrintHeader poData={poData} />
    <PoPrintBody poData={poData} />
    <InvoiceFooter />
    <div className="page-break">
      <PoFooter />
    </div>
  </div> */}

<div className="po-print-wrapper">
  
  {/* PAGE 1 */}
  <div className="po-page">
    <PoPrintHeader poData={poData} />
    <PoPrintBody poData={poData} />
  </div>

  {/* PAGE 2 */}
  {/* <div className=""></div> */}

  <div className="po-page">
    <PoFooter />
  </div>

</div>



</div>

    </>

  );
};

export default PoPrint;


//   {/* hidden duplicates */}
//   {Array.from({ length: prints - 1 }).map((_, index) => (
//    <div className="invoice-print invoice-duplicate">
//    <InvoiceHeader invoiceData={invoiceData} />
//     <InvoiceBody invoiceData={invoiceData} />
//     <InvoiceFooter />
//   </div>
//   ))}